// Approx capital/representative coordinates [longitude, latitude] by ISO 3166-1 alpha-2 code.
export const COUNTRY_COORDS = {
  // Nord America
  US: [-77.04, 38.9], CA: [-75.7, 45.42], MX: [-99.13, 19.43], CU: [-82.38, 23.13],
  GT: [-90.51, 14.63], HN: [-87.21, 14.1], PA: [-79.53, 8.98], CR: [-84.09, 9.93],
  DO: [-69.9, 18.47], JM: [-76.79, 18.01], HT: [-72.34, 18.59],
  // Sud America
  BR: [-47.93, -15.78], AR: [-58.38, -34.6], CL: [-70.65, -33.45], CO: [-74.07, 4.71],
  PE: [-77.04, -12.05], VE: [-66.9, 10.48], EC: [-78.47, -0.18], BO: [-68.15, -16.5],
  PY: [-57.63, -25.28], UY: [-56.19, -34.9],
  // Europa occidentale
  GB: [-0.13, 51.51], FR: [2.35, 48.85], DE: [13.4, 52.52], IT: [12.48, 41.9],
  ES: [-3.7, 40.42], PT: [-9.14, 38.72], NL: [4.9, 52.37], BE: [4.35, 50.85],
  CH: [7.45, 46.95], AT: [16.37, 48.21], IE: [-6.26, 53.35], LU: [6.13, 49.61],
  VA: [12.45, 41.9], MC: [7.42, 43.74], MT: [14.51, 35.9],
  // Nord Europa
  SE: [18.07, 59.33], NO: [10.75, 59.91], FI: [24.94, 60.17], DK: [12.57, 55.68],
  IS: [-21.94, 64.15], EE: [24.75, 59.44], LV: [24.1, 56.95], LT: [25.28, 54.69],
  // Europa centro-orientale
  PL: [21.01, 52.23], CZ: [14.44, 50.08], SK: [17.11, 48.15], HU: [19.04, 47.5],
  RO: [26.1, 44.43], BG: [23.32, 42.7], GR: [23.73, 37.98], HR: [15.98, 45.81],
  SI: [14.51, 46.06], RS: [20.46, 44.79], BA: [18.41, 43.86], AL: [19.82, 41.33],
  MK: [21.43, 41.99], MD: [28.86, 47.01], UA: [30.52, 50.45], BY: [27.57, 53.9],
  ME: [19.26, 42.44], XK: [21.17, 42.67],
  // Russia e Caucaso / Asia centrale
  RU: [37.62, 55.75], GE: [44.79, 41.72], AM: [44.51, 40.18], AZ: [49.87, 40.41],
  KZ: [71.43, 51.13], UZ: [69.24, 41.31], TM: [58.38, 37.95], KG: [74.6, 42.87],
  TJ: [68.79, 38.56],
  // Medio Oriente
  TR: [32.86, 39.93], IL: [35.21, 31.77], PS: [35.23, 31.9], SA: [46.72, 24.71],
  IR: [51.39, 35.69], IQ: [44.36, 33.31], SY: [36.29, 33.51], JO: [35.93, 31.95],
  LB: [35.5, 33.89], AE: [54.37, 24.45], QA: [51.53, 25.29], KW: [47.98, 29.38],
  BH: [50.59, 26.23], OM: [58.41, 23.59], YE: [44.19, 15.35],
  // Asia meridionale e orientale
  CN: [116.4, 39.9], JP: [139.69, 35.69], KR: [126.98, 37.57], KP: [125.76, 39.04],
  IN: [77.21, 28.61], PK: [73.05, 33.68], BD: [90.41, 23.81], LK: [79.86, 6.93],
  NP: [85.32, 27.72], AF: [69.21, 34.56], MM: [96.16, 19.75], TH: [100.52, 13.76],
  VN: [105.85, 21.03], KH: [104.92, 11.56], LA: [102.6, 17.97], MY: [101.69, 3.14],
  SG: [103.82, 1.35], ID: [106.85, -6.21], PH: [120.98, 14.6], TW: [121.56, 25.03],
  MN: [106.92, 47.92],
  // Africa
  EG: [31.24, 30.04], LY: [13.19, 32.89], TN: [10.18, 36.81], DZ: [3.06, 36.75],
  MA: [-6.85, 34.02], ZA: [28.05, -26.2], NG: [7.49, 9.06], KE: [36.82, -1.29],
  ET: [38.75, 9.02], GH: [-0.19, 5.6], SN: [-17.44, 14.72], CI: [-4.03, 5.35],
  CM: [11.52, 3.85], TZ: [39.28, -6.82], UG: [32.58, 0.35], SD: [32.53, 15.5],
  AO: [13.23, -8.84], MZ: [32.59, -25.97], ZW: [31.05, -17.83], RW: [30.06, -1.94],
  ML: [-8.0, 12.65], LR: [-10.8, 6.3], SO: [45.34, 2.05], CD: [15.31, -4.32],
  // Oceania
  AU: [149.13, -35.28], NZ: [174.78, -41.29], FJ: [178.44, -18.12], PG: [147.18, -9.44],
};
